import React from 'react'
import { PropagateLoader } from 'react-spinners'

export const Loader = () => {
  return <PropagateLoader size={15} color={'orange'} loading={true} />
}
